'use client';

import { useQuery } from '@apollo/client';

import { CraveErrorCode } from '@/enums/errorCodes';
import { getCraveError } from '@/utils/errors';

import type { SessionContext } from '../api/generated/types_web';
import { myListQuery } from '../queries/myList';
import { MyListQueryResponse } from '../types';

export const useMyListQuery = (sessionContext: SessionContext) => {
  const { loading, error, data } = useQuery<MyListQueryResponse>(myListQuery, {
    variables: { sessionContext, limit: 300 },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  if (error)
    throw getCraveError(
      CraveErrorCode.MY_LIST_NOT_FOUND_1401,
      sessionContext.userLanguage
    );

  return {
    loading,
    error,
    myList: data?.myListItemsPage,
  };
};
